import { Navigate, useRoutes } from "react-router-dom";
import { AuthUserProvider, AuthUserRoute, UnauthUserRoute } from "./routesAuths/userAuth";
import { PageHome } from "@/pages/home";
import { LayoutRoot } from "@/pages/layouts/root";
import { PageLogin } from "@/pages/login/index";
import { PageOrders } from "@/pages/orders";
import { PageRegister } from "@/pages/register";
import { PageTrade } from "@/pages/trade";
import { PageUser } from "@/pages/user";
import { LayoutAuth } from "../pages/layouts/auth";
import { PageBuy } from "@/pages/buy";
import { PageBuyTrading } from "@/pages/buy_trading";
import { PageCryptoOrderDetail } from "@/pages/crypto_order_detail";
import { PageHelp } from "@/pages/help";
import { PageSavePayQRCode } from "@/pages/help/SavePayQRCode";
import { PageMessagesPage } from "@/pages/messages";
import { PageMessageDetail } from "@/pages/msg_detail";
import { PageMyPendingOrders } from "@/pages/my_pending_orders";
import { PagePayOrder } from "@/pages/pay_order";
import { PagePayment } from "@/pages/payment";
import { PagePaymentAdd } from "@/pages/payment_add";
import { PageQRLogin } from "@/pages/qr_login";
import { PageSell } from "@/pages/sell";
import { PageSellTrading } from "@/pages/sell_trading";
import { PageSelling } from "@/pages/selling";
import { PageCryptoEarn } from "@/pages/trade/Earn";
import user from "./user";
import { ActivePage } from "@/pages/active";
import { PageAgreementDetail } from "@/pages/agreement_detail";
import { PageCryptoTransferIn } from "@/pages/deposit_transfer/in";
import { PageCryptoTransferOut } from "@/pages/deposit_transfer/out";
import { PageExample } from "@/pages/examples";
import { PageMerchantBalanceTransout } from "@/pages/merchant_balance_transout";
import { PageProfessionDetail } from "@/pages/profession_detail";
import { PageCryptoTrading } from "@/pages/trade/CryptoTrading";
import { PageCryptoEarnAgree } from "@/pages/trade/EarnCionAgree";
import { PageTransInBalanceFromBlockchain } from "@/pages/trans_in_balance_from_blockchain";
import { wrapUseRoutes } from "@sentry/react";
export const routes = [{
  path: "/example",
  element: <PageExample />
}, {
  path: "/",
  element: <Navigate to="/root/home" replace />
}, {
  path: "/auth",
  element: <UnauthUserRoute>
        <LayoutAuth />
      </UnauthUserRoute>,
  children: [{
    path: "login",
    element: <PageLogin />
  }, {
    path: "register",
    element: <PageRegister />
  }, {
    path: "",
    element: <Navigate to="/auth/login" replace />
  }, {
    path: "*",
    element: <Navigate to="/auth/login" replace />
  }]
}, {
  path: "/unbind",
  element: <UnauthUserRoute>
        <PageLogin />
      </UnauthUserRoute>
}, {
  path: "/user_check",
  element: <AuthUserRoute>
        <PageLogin />
      </AuthUserRoute>
}, {
  path: "/qr_login",
  element: <UnauthUserRoute>
        <PageQRLogin />
      </UnauthUserRoute>
}, {
  path: "/pay_order",
  element: <AuthUserRoute>
        <PagePayOrder />
      </AuthUserRoute>
}, {
  path: "/root",
  element: <AuthUserRoute>
        <LayoutRoot />
      </AuthUserRoute>,
  children: [{
    path: "home",
    element: <PageHome />
  }, {
    path: "trade",
    element: <PageTrade />
  }, {
    path: "crypto_trading",
    element: <PageCryptoTrading />
  }, {
    path: "crypto_earn",
    element: <PageCryptoEarn />
  }, {
    path: "crypto_earn_agree",
    element: <PageCryptoEarnAgree />
  }, {
    path: "orders",
    element: <PageOrders />
  }, {
    path: "user",
    element: <PageUser />
  }]
}, {
  path: "/buy/:orderId",
  element: <AuthUserRoute>
        <PageBuy />
      </AuthUserRoute>
}, {
  path: "/active/:activeId",
  element: <AuthUserRoute>
        <ActivePage />
      </AuthUserRoute>
}, {
  path: "/buy_trading/:orderId",
  element: <AuthUserRoute>
        <PageBuyTrading />
      </AuthUserRoute>
}, {
  path: "/sell",
  element: <AuthUserRoute>
        <PageSell />
      </AuthUserRoute>
}, {
  path: "/selling/:pendingOrderId",
  element: <AuthUserRoute>
        <PageSelling />
      </AuthUserRoute>
}, {
  path: "/sell_trading/:orderId",
  element: <AuthUserRoute>
        <PageSellTrading />
      </AuthUserRoute>
}, {
  path: "/my_pending_orders",
  element: <AuthUserRoute>
        <PageMyPendingOrders />
      </AuthUserRoute>
}, {
  path: "/messages/:tab",
  element: <AuthUserRoute>
        <PageMessagesPage />
      </AuthUserRoute>
}, {
  path: "/msg_detail",
  element: <AuthUserRoute>
        <PageMessageDetail />
      </AuthUserRoute>
}, {
  path: "/payment",
  element: <AuthUserRoute>
        <PagePayment />
      </AuthUserRoute>,
  children: [{
    path: "/payment/:type",
    element: <AuthUserRoute>
            <PagePayment />
          </AuthUserRoute>
  }]
}, {
  path: "/payment_add/:type",
  element: <AuthUserRoute>
        <PagePaymentAdd />
      </AuthUserRoute>
}, {
  path: "/trade/crypto_trading/:orderNo",
  element: <AuthUserRoute>
        <PageCryptoOrderDetail />
      </AuthUserRoute>
}, {
  path: "/deposit_transfer/deposit_transfer_in",
  element: <AuthUserRoute>
        <PageCryptoTransferIn />
      </AuthUserRoute>
}, {
  path: "/deposit_transfer/deposit_transfer_out",
  element: <AuthUserRoute>
        <PageCryptoTransferOut />
      </AuthUserRoute>
}, {
  path: "/deposit_transfer/trans_in_balance_from_blockchain",
  element: <AuthUserRoute>
        <PageTransInBalanceFromBlockchain />
      </AuthUserRoute>
}, {
  path: "/deposit_transfer/merchant_balance_transout",
  element: <AuthUserRoute>
        <PageMerchantBalanceTransout />
      </AuthUserRoute>
}, {
  path: "/helps",
  element: <AuthUserRoute>
        <PageHelp />
      </AuthUserRoute>
}, {
  path: "/how_to_save_receive_code/:type",
  element: <AuthUserRoute>
        <PageSavePayQRCode />
      </AuthUserRoute>
}, {
  path: "/agreement_detail",
  element: <AuthUserRoute>
        <PageAgreementDetail />
      </AuthUserRoute>
}, {
  path: "/sale",
  element: <AuthUserRoute>
        <PageAgreementDetail />
      </AuthUserRoute>
}, {
  path: "/profession_detail",
  element: <AuthUserRoute>
        <PageProfessionDetail />
      </AuthUserRoute>
}, ...user, {
  path: "*",
  element: <Navigate to="/" replace />
}];
const useSentryRoutes = wrapUseRoutes(useRoutes);
const Routes = () => {
  return useSentryRoutes(routes);
};
const Router = () => {
  return <AuthUserProvider data-sentry-element="AuthUserProvider" data-sentry-component="Router" data-sentry-source-file="index.tsx">
      <Routes data-sentry-element="Routes" data-sentry-source-file="index.tsx" />
    </AuthUserProvider>;
};
export default Router;